import * as _ from 'underscore';
import { translations as fr } from '../../../translations/fr';
import { translations as en } from '../../../translations/en';
import { downgradeInjectable } from '@angular/upgrade/static';
import { TranslateService } from '@ngx-translate/core';
angular
    .module('PlatformExam')
    .config([
    '$mdInkRippleProvider',
    '$windowProvider',
    function ($mdInkRippleProvider, $windowProvider) {
        function isIE() {
            var userAgent = $windowProvider.$get().navigator.userAgent;
            var msie = userAgent.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), 10);
            }
            var trident = userAgent.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = userAgent.indexOf('rv:');
                return parseInt(userAgent.substring(rv + 3, userAgent.indexOf('.', rv)), 10);
            }
            return false;
        }
        if (isIE()) {
            $mdInkRippleProvider.disableInkRipple();
        }
    }
])
    .config([
    '$compileProvider',
    '$mdDialogProvider',
    function ($compileProvider, $mdDialogProvider) {
        $compileProvider.debugInfoEnabled(false);
        $mdDialogProvider.addPreset('ng', {
            options: function () {
                return {
                    preserveScope: true,
                    parent: angular.element(document.body)
                };
            }
        });
    }
])
    .config([
    '$httpProvider',
    function ($httpProvider) {
        $httpProvider.defaults.withCredentials = false;
        // $httpProvider.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
        $httpProvider.interceptors.push([
            '$q',
            '$injector',
            '$location',
            'API_URL',
            '$translate',
            function ($q, $injector, $location, API_URL, $translate) {
                return {
                    request: function (config) {
                        return config || $q.when(config);
                    },
                    responseError: function (response) {
                        console.log(JSON.stringify(response));
                        if (response.status <= 0) {
                            // We are offline
                            var url = response.config.url;
                            if (url.indexOf(API_URL) > -1 &&
                                (url.indexOf('stats') > -1 ||
                                    url.indexOf('me') > -1 ||
                                    url.indexOf('results') > -1 ||
                                    url.indexOf('lesson') > -1 ||
                                    url.indexOf('words') > -1)) {
                                return $q.reject(response); // No toast since this should be cached with api.sync
                            }
                            if (url.indexOf('formspree.io') > -1) {
                                return $q.reject(response);
                            }
                            var $mdToast = $injector.get('$mdToast');
                            $mdToast.show($mdToast
                                .simple()
                                .textContent($translate.instant(['toasts.offline'])['toasts.offline'])
                                .position('bottom right'));
                            return $q.reject(response);
                        }
                        if (response.status === 401) {
                            var url = $location.url();
                            url = url.split('?')[0];
                            console.log(url);
                            // list of url which doesn't need authentication
                            var urlArray = [
                                '/',
                                '',
                                '/login',
                                '/register',
                                '/activation',
                                '/concept',
                                '/about',
                                '/contact',
                                '/nos-offres',
                                '/pricing',
                                '/blog',
                                '/partners',
                                '/password/reset',
                                '/password/reset_validation',
                                '/lesson',
                                '/cours',
                                '/terms',
                                '/legals',
                                '/cgv',
                                '/credits',
                                '/cpf-mon-compte-compte-formation'
                            ];
                            var reArray = [
                                '/salaries.*',
                                '/sso.*',
                                '/t/.*',
                                '/organismes-de-formation.*',
                                '/etudiants.*',
                                '/contact/universite.*',
                                '/contact/organisme-formation.*',
                                '/contact/entreprise.*',
                                '/newsletter.*',
                                '/password/reset_validation.*',
                                '/lesson/d*',
                                '/cours/d*',
                                '/blog/d*'
                            ];
                            var re = new RegExp(reArray.join('|'), 'i');
                            var needAuthentication = true;
                            // test constant array
                            needAuthentication = !!!_.find(urlArray, function (link) {
                                return url === link;
                            });
                            // test regex array
                            if (needAuthentication && re.test(url)) {
                                needAuthentication = false;
                            }
                            // Redirect to login if need authentication
                            if (needAuthentication) {
                                $location.url('/login');
                            }
                        }
                        else if (response.status === 402) {
                            var pricing = $injector.get('pricing');
                            pricing.showPrices();
                            //$location.url('/activation');
                        }
                        else if (response.status === 403) {
                            if (response.data.title == 'Invalid Token' ||
                                response.data.title == 'Expired Token') {
                                var api = $injector.get('api');
                                api.data.token = null;
                                api.data.me = null;
                                localStorage.setItem('api', JSON.stringify(api.data));
                                $location.url('/login'); // Token invalid/expired => need to re-login
                                var $mdToast = $injector.get('$mdToast');
                                $mdToast.show($mdToast
                                    .simple()
                                    .textContent($translate.instant(['toasts.expired_token'])['toasts.expired_token'])
                                    .position('bottom right'));
                            }
                        }
                        return $q.reject(response);
                    }
                };
            }
        ]);
    }
])
    .config([
    '$locationProvider',
    function ($locationProvider) {
        $locationProvider.hashPrefix('!');
        $locationProvider.html5Mode(true);
    }
])
    .config([
    '$compileProvider',
    function ($compileProvider) {
        $compileProvider.debugInfoEnabled(false);
    }
])
    .config([
    '$translateProvider',
    function ($translateProvider) {
        const preferredLanguage = window.localStorage.getItem('lang') || 'fr';
        $translateProvider
            .translations('fr', fr)
            .translations('en', en)
            .preferredLanguage(preferredLanguage);
    }
])
    .factory('translateService', downgradeInjectable(TranslateService))
    .directive('a', function () {
    return {
        priority: 1,
        restrict: 'E',
        link: function ($scope, $element, $attrs) {
            $attrs.$observe('href', function (value) {
                if (value && value.indexOf('#') === 0 && value.indexOf('!') === 1) {
                    $attrs.$set('href', '/' + value);
                }
            });
        }
    };
});
hello.init({
    facebook: '367497400125453',
    google: '391191122355-5im3m29dc0bq3p4bspjgd953gmb7vrpv.apps.googleusercontent.com'
}, {
    redirect_uri: window.location.href.split('?')[0],
    scope: 'email'
});
var DEBUG = true;
if (!DEBUG) {
    if (!window.console) {
        window.console = {};
    }
    var methods = ['log', 'debug', 'warn', 'info'];
    for (var i = 0; i < methods.length; i++) {
        console[methods[i]] = function () { };
    }
}
//# sourceMappingURL=config.js.map